export default __webpack_public_path__ + "static/media/InterPAO.cd0e64b0.svg";